export type { TagProps } from './tag'
export { default as Tag } from './tag'

export type { SingleTagProps, TagGroupProps } from './tag-group'
export { default as TagGroup } from './tag-group'
